import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { GoogleCloudStorageLinkedService } from './google-cloud-storage.linkedservice';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: ModelConstants.sapDatasphereForGoogleCloudStorageLinkedService,
    display: [
        format(
            shellStringResources.ModelName_LinkedServiceTemplate,
            shellStringResources.SapDatasphereForGoogleCloudStorageLinkedService_DisplayText
        ),
        format(
            shellStringResources.ModelName_LinkedServicesTemplate,
            shellStringResources.SapDatasphereForGoogleCloudStorageLinkedService_DisplayText
        )
    ]
})
export class SapDatasphereForGoogleCloudStorageLinkedService extends GoogleCloudStorageLinkedService {
    public static readonly MODEL: IModel;
}
